import { jsx as a } from "react/jsx-runtime";
import { Textarea as t } from "flowbite-react";
import { forwardRef as o } from "react";
import { theme as m } from "./theme.js";
const f = o(
  (r, e) => /* @__PURE__ */ a(t, { theme: m, ...r, ref: e })
);
f.displayName = "Textarea";
export {
  f as Textarea
};
